module.exports = __webpack_public_path__ + "static/ari-melenciano-abe1ae2f00cb81ada14885256c2f960a.jpg";